import { Fragment, FunctionComponent, KeyboardEvent } from "react";
import { KeyNumberSelection } from "@App/Components/Vehicletree/KeyNumberSelection";
import { KeyNumberApproval } from "@App/Components/Vehicletree/KeyNumberApproval";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { useTranslation } from "react-i18next";
import { Motorization } from "@App/types";
import { bindActionCreators } from "@reduxjs/toolkit";
import { Button } from "@App/Components/Funnel/Button";
import { FunnelHeader } from "@App/Components/Funnel/FunnelHeader";

export type KeyNumberProps = {
  headline: string;
  step: number;
  maxSteps: number;
  onVehicletreeLinkClick?: () => void;
  onSubmit?: () => void;
};

export const KeyNumber: FunctionComponent<KeyNumberProps> = ({
  headline,
  step,
  maxSteps,
  onSubmit,
  onVehicletreeLinkClick,
}: KeyNumberProps) => {
  const key = useSelector((state: State) => state.orders.key);
  const motorization = useSelector((state: State) => state.orders.motorization);

  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { chooseBrand, chooseGeneration, chooseMotorization } = bindActionCreators(
    actionCreators,
    dispatch,
  );

  // sets the brand, generation and motorization
  const setVehicle = (keyNumber): void => {
    chooseBrand(keyNumber.brand);
    chooseGeneration(keyNumber.generation);
    chooseMotorization(keyNumber.motorization);
  };

  // unsets all previous selections and returns to brand selection
  const backToVehicletree = () => {
    chooseBrand(null);
    chooseGeneration(null);
    chooseMotorization(null);
    onVehicletreeLinkClick && onVehicletreeLinkClick();
  };

  // submits users selection
  const submit = (): void => {
    onSubmit && onSubmit();
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (motorization && e.key === "Enter") {
      submit();
    }
  };

  return (
    <Fragment>
      <div
        className="
                    container bg-white
                    pt-10 pb-12
                "
      >
        <FunnelHeader
          heading={headline}
          step={step}
          maxSteps={maxSteps}
          subheading={t("keyNumber.headline")}
        />
        <div className="text-sm text-neutral-700 mb-8">
          <i>
            {t("keyNumber.to-brand")}{" "}
            <span
              className="text-primary font-bold underline cursor-pointer"
              onClick={backToVehicletree}
            >
              {t("keyNumber.brand-selection")}
            </span>
            .
          </i>
        </div>
        <KeyNumberSelection handleKeyDown={handleKeyDown} />
        {key.hsn.length > 2 && key.tsn.length > 2 && (
          <KeyNumberApproval
            onSelectMotorization={(motorization: Motorization) => setVehicle(motorization)}
          />
        )}

        <Button title={t("keyNumber.submit")} disabled={motorization === null} onClick={submit} />
      </div>
    </Fragment>
  );
};
